import BlurBlueBlock1 from '@assets/images/BlurBlueBlock1.webp';
import BlurBlueBlock2 from '@assets/images/BlurBlueBlock2.webp';
import BlurOrangeBlock from '@assets/images/BlurOrangeBlock.webp';
import InteractiveEmployeeContent from '@assets/images/InteractiveEmployeeContent.png';
import PointsRewardSystem from '@assets/images/PointsRewardSystem.png';
import RecognitionProgram from '@assets/images/RecognitionProgram.png';
import { IMediaSideContentProps, MediaSideContent, VideoPlayer } from '@components';
import { GradientBackgroundVideoPlaySource } from '@constants/videos';
import { SEOLayout } from '@layouts';
import Image from 'next/image';
import { AdminPortal } from './components/AdminPortal';
import { HeroContent } from './components/HeroContent';
import { OurPartners } from './components/OurPartners';
import { QuoteContent } from './components/QuoteContent';
import { WhyPerksBar } from './components/WhyPerksBar';
import styles from './styles.module.scss';

const Home = () => {
  const mediaSideContent: Omit<IMediaSideContentProps, 'index'>[] = [
    {
      title: 'Recognition Program',
      content: 'Peer-to-peer recognition wall and manager recognition program.',
      src: RecognitionProgram,
    },
    {
      title: 'Interactive Employee Content',
      content:
        'Content portal for internal comms, interactive quiz and surveys for employee workshops.',
      src: InteractiveEmployeeContent,
    },
    {
      title: 'Points & Reward System',
      content: 'PerksBar partnered with 10+ reward merchants, reward your employees effortlessly.',
      src: PointsRewardSystem,
    },
  ];

  return (
    <SEOLayout
      title="PerksBar | Reward and Recognition HR Platform"
      description="Transform your workplace with PerksBar’s leading Employee & Rewards Benefits app. Engage employee, automate HR strategy, and foster a positive company culture."
    >
      <main className={styles.container}>
        <div className={styles.wavyContent}>
          <VideoPlayer className={styles.gradientVideo} {...GradientBackgroundVideoPlaySource} />
          <div className={styles.gradientVideoWhiteLinearGradient} />
          <Image className={styles.blurBlueBlock1} alt="" src={BlurBlueBlock1} />
          <Image className={styles.blurBlueBlock2} alt="" src={BlurBlueBlock2} />
          <Image className={styles.blurOrangeBlock} alt="" src={BlurOrangeBlock} />
          <HeroContent />
          <WhyPerksBar />
          <OurPartners />
          <QuoteContent />
        </div>
        {mediaSideContent.map((item, index) => (
          <MediaSideContent
            {...item}
            key={item.title}
            index={index + 1}
            isLastItem={index === mediaSideContent.length - 1}
          />
        ))}
        <AdminPortal />
      </main>
    </SEOLayout>
  );
};

export default Home;
